export const ru = {
    title: 'Отправьтесь в первую командировку вместе с Яндексом',
    add_email_caption: 'Пожалуйста, укажите вашу рабочую почту, которая привязана к домену компании',
};
